<template>
  <div id="Index">
    <jw-frame>
      <template slot="extra">
        <i-button type="primary" @click="$refs['news'].editNewsInfo('create',{})">添加新闻</i-button>
      </template>

      <Form ref="formInline" :model="filter" inline>
        <FormItem prop="user">
          <Input type="text" v-model="filter.new_title" placeholder="新闻标题"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="onGetNewsList">搜 索</Button>
        </FormItem>
      </Form>

      <table width="100%;">
        <thead>
        <tr>
          <th style="width: 50px;">新闻封面</th>
          <th style="width: 160px;">新闻标题</th>
          <th style="width: 90px;text-align: center;">作者</th>
          <th style="width: 200px;text-align: left;">简介</th>
          <th style="width: 90px;text-align: left;">发布时间</th>
          <th style="width: 120px;text-align: center;">编辑</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(news, index) in list" :class="[index%2 === 0 ? 'noHover' : 'hover']">
          <td style="text-align: left;">
            <img :src="news.cover" style="width: 180px;height: 90px;">
          </td>
          <td style="width: 160px;text-align: left;">
            {{news['new_title']}}
          </td>
          <td style="width: 90px;text-align: center;">
            {{news['author']}}
          </td>
          <td style="width: 200px;text-align: left;">
            {{news['brief']}}
          </td>
          <td style="width: 90px;text-align: left;">
            {{news['create_time']}}
          </td>
          <td style="width: 120px;text-align: center;">
            <i-button type="text" @click="$refs['news'].editNewsInfo('update', news)">修改</i-button>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="10" style="text-align: center;padding: 10px 0;">
            暂未查询到新闻记录
          </td>
        </tr>
        </tbody>
      </table>

      <div style="text-align: center;margin-top: 10px;">
        <Page
            @on-change="handlePageChangeAction"
            @on-page-size-change="handlePageSizeChangeAction"
            :total="total"
            :page-size="this.page.pageSize"
            show-sizer
        />
      </div>
    </jw-frame>
    <news-detail ref="news" @refresh="onGetNewsList"></news-detail>
  </div>
</template>

<script>
import {getNewList} from "@/request/news";
import NewsDetail from "@/views/admin/news/NewsDetail.vue";

export default {
  name: "Index",
  // 注册组件
  components: {
    NewsDetail
  },
  data() {
    return {
      filter: {
        unit_name: ''
      },
      total: 0,
      page: {
        pageIndex: 1,
        pageSize: 10
      },
      list: []
    }
  },
  created() {
    this.onGetNewsList()
  },
  methods: {
    handlePageChangeAction(index) {
      this.page.pageIndex = index;
      this.onGetNewsList();
    },
    handlePageSizeChangeAction(size) {
      this.page.pageIndex = 1;
      this.page.pageSize = size;
      this.onGetNewsList()
    },
    // 获取新闻列表
    onGetNewsList() {
      getNewList({
        ...this.page,
        filter: this.filter
      }).then(res=> {
        let {total, list} = res.data.data
        this.total = total
        this.list = list
      })
    },
  }
}
</script>

<style scoped>
table {
  text-align: left;
  width: 100%;
  color: #1fbba6;
  font-weight: bold;
  border-collapse:collapse;
}

table thead {
  color: #fff;
  background-color: #1fbba6
}

table thead tr {
  color: #fff;
}

table thead tr th {
  padding: 10px 5px;
  height: 44px;
}

table tbody tr:hover {
  cursor:default;
  background-color: rgba(104, 216, 254, 0.4);
}

table tbody tr td{
  padding: 8px 5px;
}

table body tr td p{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

table tbody .hover {
  background-color: rgba(255, 255, 255, 0.5)
}

table tbody .noHover {
  background-color: rgba(128, 134, 149, 0.15)
}
</style>
